/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarContact_item = {|
  +isCustomizable: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item",
      "args": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
